import { gql } from '@apollo/client'

export const FRAGMENT_TERRITORY_PERFORMANCE_TOTAL_METRICS = gql`
  fragment FragmentTerritoryPerformanceTotalMetrics on TerritoryPerformance {
    totalPosts(timeRange: $timeRange, providers: $providers)
    totalCreators(timeRange: $timeRange, providers: $providers)
  }
`
